import React, { useState } from 'react';
import { connect, useIntl } from 'umi';
import { Layout } from 'tea-component';
import { FilterFixed, useFilterDataHook } from '../../components/FilterCommon';
import CardLoading from '../../components/CardLoading';
import NIKKEPoint from '@op/operationLog/pages/NIKKE';
import { useInitBuriedPointInfo } from '../../operationLog/buriedPoint';
import ContentBody from '../../components/ContentBody';
import { PAGE_NAME } from '@op/constants/page';
import { dealwithCondHero, HeroMapType } from '../Hero/utils';
import NIKKETable from './components/NIKKETable';
import NIKKEChart from './components/NIKKEChart';
import './index.scss';

const { Content } = Layout;

function NIKKE({ gameInfo, wholeGameInfo }: any) {
  useInitBuriedPointInfo({ buriedPoint: NIKKEPoint });

  const [heroMap, setHeroMap] = useState<HeroMapType>({});
  const { formatMessage } = useIntl();
  const { loading, filter, changeFilter, scrollBody, filterOptions, filterCommonParams } =
    useFilterDataHook({ pageName: 'Overview_NIKKE' });

  return (
    <Content className="dbo-hero dbo-hero--nikke" ref={scrollBody}>
      <ContentBody
        pageName={PAGE_NAME.NIKKE}
        contentHeard={
          <Content.Header title={formatMessage({ id: PAGE_NAME.NIKKE })} />
        }
      >
        <FilterFixed
          filter={filterOptions}
          confirm={(value: any) => {
            const { keyword_en, ...otherProps } = value;
            changeFilter({
              sentiment_type: 'total',
              topic: keyword_en,
              ...otherProps,
              ...gameInfo,
            });
          }}
          {...filterCommonParams}
          backCondOriginData={(data) => {
            setHeroMap(dealwithCondHero(data?.hok_hero || {}));
          }}
          scrollBody={scrollBody}
        ></FilterFixed>
        <CardLoading loading={loading}>
          <NIKKETable
            wholeGameInfo={wholeGameInfo}
            filter={filter}
            heroInfoMap={heroMap}
          >
            {({ transHeroInfo, filter, loading, selectedKeysMap }) => {
              return (
                <NIKKEChart
                  transHeroInfo={transHeroInfo}
                  filter={filter}
                  beforeLoading={loading}
                  heroInfoMap={heroMap}
                  selectedKeysMap={selectedKeysMap}
                  gameInfo={gameInfo}
                ></NIKKEChart>
              );
            }}
          </NIKKETable>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}
export default connect((state: { opinionCommon: any }) => {
  const { opinionCommon } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(NIKKE);
